import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2125a664"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "left-menu" }
const _hoisted_3 = { class: "hanburger-container" }
const _hoisted_4 = { class: "right-menu" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "user-name-text" }
const _hoisted_7 = { class: "current-release" }
const _hoisted_8 = { class: "release-log-header" }
const _hoisted_9 = { class: "release-log-title" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "扫码绑定成功", -1))
const _hoisted_14 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_15 = { class: "account-details" }
const _hoisted_16 = { class: "detail-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "登录账号", -1))
const _hoisted_18 = { class: "detail-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "昵称", -1))
const _hoisted_20 = { class: "detail-row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "手机号", -1))
const _hoisted_22 = { class: "detail-row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "角色", -1))
const _hoisted_24 = { class: "detail-row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "创建时间", -1))
const _hoisted_26 = { class: "detail-row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "登录时间", -1))
const _hoisted_28 = { class: "detail-row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "所属机构", -1))
const _hoisted_30 = { class: "detail-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "机构类型", -1))
const _hoisted_32 = { class: "client-commands" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hanbuger = _resolveComponent("Hanbuger")!
  const _component_Navgater = _resolveComponent("Navgater")!
  const _component_SelectTheam = _resolveComponent("SelectTheam")!
  const _component_Language = _resolveComponent("Language")!
  const _component_c_bridge = _resolveComponent("c-bridge")!
  const _component_QuestionCircleOutlined = _resolveComponent("QuestionCircleOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_GptQuestionPanel = _resolveComponent("GptQuestionPanel")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_SystemMaintenanceControl = _resolveComponent("SystemMaintenanceControl")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Hanbuger, { icon: "hamburger-opened" })
      ]),
      _createVNode(_component_Navgater)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SelectTheam),
      _createVNode(_component_Language),
      _createVNode(_component_c_bridge, {
        count: _ctx.messageCount,
        onClick: _ctx.showMessage,
        style: {"margin-right":"30px"}
      }, null, 8, ["count", "onClick"]),
      (_ctx.canAskQuestions)
        ? (_openBlock(), _createBlock(_component_GptQuestionPanel, { key: 0 }, {
            default: _withCtx(({ openPanel }) => [
              _createVNode(_component_a_tooltip, { title: "提问" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    class: "question-trigger",
                    type: "text",
                    title: "提问",
                    "aria-label": "提问",
                    onClick: openPanel
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_QuestionCircleOutlined)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_tooltip, { title: "版本日志" }, {
        default: _withCtx(() => [
          _createVNode(_component_svg_icon, {
            class: "svgi",
            icon: "histoires",
            style: {"width":"24px","margin-right":"10px"},
            onClick: _ctx.openReleaseLog
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      (_ctx.canManageSystemMaintenance)
        ? (_openBlock(), _createBlock(_component_SystemMaintenanceControl, { key: 1 }, {
            default: _withCtx(({ openPanel }) => [
              _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, {
                        key: "system-maintenance",
                        onClick: openPanel
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("系统维护")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_tooltip, { title: "设置" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_icon, {
                        class: "svgi",
                        icon: "setting",
                        style: {"width":"24px","margin-right":"20px"},
                        tabindex: "0",
                        role: "button",
                        "aria-label": "设置"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            class: "svgi",
            icon: "setting",
            style: {"width":"24px","margin-right":"20px"}
          })),
      _createVNode(_component_a_dropdown, null, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, null, {
            default: _withCtx(() => [
              (!_ctx.userInfo.ghOpenId)
                ? (_openBlock(), _createBlock(_component_a_menu_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = ()=>{_ctx.ghopen.open=true,_ctx.getQrcode(),_ctx.getOpenId()})
                      }, "绑定公众号")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_menu_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: _cache[2] || (_cache[2] = ()=>{_ctx.open=true})
                  }, "账号信息")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = ()=>{_ctx.showPwdEditing=true})
                  }, "修改密码")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menu_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, "退出登录")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "ant-dropdown-link",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("img", {
              src: _ctx.userInfo.avatar,
              alt: ""
            }, null, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userInfo.nickName), 1),
            _createVNode(_component_svg_icon, { icon: "cart-down" })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.releaseLogVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.releaseLogVisible) = $event)),
      title: "版本日志",
      footer: null,
      width: 620
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, "当前版本：V" + _toDisplayString(_ctx.releaseInfo.version), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.releaseInfo.logs, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "release-log",
            key: item.version+'-'+index
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("strong", null, "V" + _toDisplayString(item.version), 1),
              _createElementVNode("span", null, _toDisplayString(item.releaseDate), 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.changes, (change, changeIndex) => {
                return (_openBlock(), _createElementBlock("li", { key: changeIndex }, _toDisplayString(change), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.showPwdEditing,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showPwdEditing) = $event)),
      title: "修改密码"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.updatePwd
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          onClick: _cache[10] || (_cache[10] = ()=>{_ctx.showPwdEditing=false})
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formInfo",
          model: _ctx.editPwdFormData,
          name: "basic",
          "label-col": {style: { width: '110px' }},
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "登录名:",
              name: "loginName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  readonly: "",
                  value: _ctx.editPwdFormData.loginName,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editPwdFormData.loginName) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "原始密码:",
              name: "password",
              help: _ctx.pwdStatus.passwordHelp,
              "validate-status": _ctx.pwdStatus.passwordStatus,
              rules: [{ required: true, message: '请录入原始密码!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.editPwdFormData.password,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editPwdFormData.password) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["help", "validate-status"]),
            _createVNode(_component_a_form_item, {
              label: "新密码:",
              name: "newPassword",
              rules: [{validator: _ctx.validatePassword,trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.editPwdFormData.newPassword,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editPwdFormData.newPassword) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, {
              label: "新密码:",
              name: "confirmPwd",
              rules: [{ validator: _ctx.retryValidatePassword,trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: _ctx.editPwdFormData.confirmPwd,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editPwdFormData.confirmPwd) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["rules"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.ghopen.open,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ghopen.open) = $event)),
      width: 300,
      title: "绑定微信公众号"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (!_ctx.qrcodeUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_loading_outlined, { style: {"font-size":"18px","color":"green"} }),
                _createTextVNode("  正在生成二维码……")
              ]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                style: {"width":"250px"},
                src: _ctx.qrcodeUrl,
                alt: ""
              }, null, 8, _hoisted_11))
        ]),
        (_ctx.ghopen.msg)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_svg_icon, {
                style: {"font-size":"16px"},
                icon: "success"
              }),
              _hoisted_13
            ]))
          : (_ctx.qrcodeUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, "绑定公众号接收消息提醒"))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.open,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.open) = $event)),
      title: "账号信息"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_a_button, {
            onClick: _cache[13] || (_cache[13] = ()=>{_ctx.open=false}),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            onClick: _cache[14] || (_cache[14] = ()=>{_ctx.open=false})
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.loginName), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.nickName), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.phone), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.roleName), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", null, _toDisplayString(_ctx.dayjs(_ctx.userInfo.createTime).format('YYYY-MM-DD HH:mm:ss')), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", null, _toDisplayString(_ctx.dayjs(_ctx.userInfo.lastLoginTime).format('YYYY-MM-DD HH:mm:ss')), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", null, _toDisplayString(_ctx.userInfo.orgName), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", null, _toDisplayString(_ctx.convertOrgType(_ctx.userInfo.orgType)), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}